// Angular
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

// NGRX
import { Store, select } from '@ngrx/store';
import { Observable, of, throwError } from 'rxjs';

// OLCI
import * as fromRoot from '../../../reducers';
import * as olci from '../../../actions/olci';
import { TealiumService } from './tealium.service';
import { TelemetryErrorData } from 'src/app/shared/interfaces';
import { RequestManagerService } from './request-manager.service';
import { SplunkService } from '../../../shared/services/splunk.service';
import { constants, OnlineCheckinErrorCodeConstants } from '../../../constants';

@Injectable()
export class ErrorService {
  public _errors: Observable<any>;
  private errorsExemptionList: number[];

  constructor(
    private readonly router: Router,
    private readonly store: Store<fromRoot.AppState>,
    private splunkService: SplunkService,
    private readonly tealiumService: TealiumService,
    private requestManagerService: RequestManagerService,
  )
  {
    this._errors = this.store.pipe(select(fromRoot.getResponseErrors));
    this.errorsExemptionList = [
      OnlineCheckinErrorCodeConstants.SAVE_PERSONAL_DETAILS_INVALID_LOYALTY,
    ];
  }

  public sendToErrorPage() {
    this.router.navigate([constants.ROUTES.ERROR]);
  }

  public setResponseError(error: HttpErrorResponse) {
    this.store.dispatch(new olci.SetResponseErrorAction(error));
  }

  get errors() {
    return this._errors;
  }

  public isStatusCodeInExemptionList(statusCode: number): boolean {
    return this.errorsExemptionList.indexOf(statusCode) !== -1;
  }

  public defaultTelemetryHttpCatch(
    error: HttpErrorResponse | any,
    telemetryErrorData: TelemetryErrorData,
    url: string,
    body?: any,
  ): Observable<any> {
    if (error?.status === 200) {
      return of(error);
    }
    const payloadContext = this.requestManagerService.requestContextOptionsFactory(url, body);
    const context = this.splunkService.initializeContext(
      ['error', 'message'],
      [
        this.splunkService.getTelemetryErrorObject(error, url, payloadContext),
        telemetryErrorData.message,
      ]
    );

    const splunkError = this.splunkService.errorByLookUp(
      telemetryErrorData.lookup,
      { context }
    );
    this.tealiumService.dispatchAnalyticsBackendError(splunkError);
    error = { ...error, errorIdentifier: splunkError?.eventId };
    return throwError(() => error);
  }
}
